/**
 * Part5（ONA具体化）の入力モード切替設定。
 *
 * 'ona'     … 現行の ONA具体化（O-11 4択 / O-12 3択）
 * 'namegen' … ネームジェネレータ（所属部署内の同僚を最大3名選択）。§03つながり構造レベルB用の入力。
 *
 * 想定: 本番は会社単位設定（companies のフラグ）から決定する。
 * 現状はその切替点を1か所に集約し、デモ/検証では localStorage で上書きできるようにしている。
 * 既定は 'ona'（実フローの挙動を変えない）。'namegen' 有効化には同僚一覧API＋保存マッピング(バックエンド)が必要。
 */
export type Part5Mode = 'ona' | 'namegen';

// 基本方針1(2026-07-05 確定): ONA具体化の代わりにネームジェネレータを全社一律で採用。
// 既定を 'namegen' とする（会社単位フラグでの出し分けは当面行わない）。
export const DEFAULT_PART5_MODE: Part5Mode = 'namegen';

const STORAGE_KEY = 'gb74_part5_mode';

export function getPart5Mode(): Part5Mode {
  if (typeof window !== 'undefined') {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (v === 'ona' || v === 'namegen') return v;
  }
  return DEFAULT_PART5_MODE;
}

export function setPart5Mode(mode: Part5Mode): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, mode);
  }
}
